
import Vue from 'vue';
import ModalPortal from './ModalPortal.vue';
import CloseIcon from '../../Icons/CloseIcon.vue';
import { appendPx } from '../Token/helper/tokenHelper';

/**
 * Modal Component.
 *
 * Pop up to show more information.
 */
export default Vue.extend({
  name: 'Modal',
  components: {
    ModalPortal,
    CloseIcon
  },
  props: {
    /**
     * ID of HTML modal.
     */
    id: {
      type: String,
      default: ''
    },
    /**
     * Open / active state of modal.
     */
    active: {
      type: Boolean,
      default: false
    },
    /**
     * Callback when modal is closed.
     */
    onClose: {
      type: Function
    },
    /**
     * Show Close icon in the top right corner of the modal.
     */
    showCloseButton: {
      type: Boolean,
      default: true
    },
    /**
     * Make modal full height.
     */
    fullHeight: {
      type: Boolean,
      default: false
    },
    /**
     * Padding content of the modal.
     */
    padding: {
      type: Number,
      default: 16
    },
    /**
     * Close icon color.
     */
    closeIconColor: {
      type: String,
      default: '#000'
    }
  },
  methods: {
    handleClose() {
      /**
       * Handle when modal is closed
       * @event close
       * @type {function}
       */
      this.$emit('close');
    }
  },
  computed: {
    modalPadding() {
      return appendPx(this.padding);
    }
  }
});
